import { render, staticRenderFns } from "./btnBox.vue?vue&type=template&id=1befaf24"
import script from "./btnBox.vue?vue&type=script&lang=js"
export * from "./btnBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports